module.exports = __webpack_public_path__ + "od-cross-icon/od-cross-icon-b291433871d1a7322205181e6a28e15c.svg";